import ExpenseNoteFormConfig from "./form";
import GenericForm from "../GenericForm";
import { ExpenseNoteFormData, ExpenseNoteRelatedAttributes } from "@/formTypes/ExpenseNoteDataType";
import { ExpenseNoteApi, ExpenseNoteDataType } from "@/api/ExpenseNoteApi";
import { useLayoutEffect, useRef, useState } from "react";
import { getDefaultCurrency } from "@utils/Currency";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";
import LoadXmlDataForm from "@components/dynamic/LoadXmlDataForm";
import LoadingScreen from "@components/content/LoadingScreen";
import { loadXmlDocument } from "@utils/EDocument";
import { showAlert } from "@utils/Alert";
import { omitProperties } from "@utils/Utils";
import { ExpenseDataType } from "@/api/ExpenseApi";

type ExpenseNoteFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string,
  expense?: ExpenseDataType;
}

const ExpenseNoteForm = (props: ExpenseNoteFormProps) => {
  const { expense } = props;
  const [defaultData, setDefaultData] = useState<ExpenseNoteDataType>({});
  const formRef = useRef<DynamicFormRef>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);


  useLayoutEffect(() => {
    const run = async () => {
      const defaultCurrency = await getDefaultCurrency()
      if (defaultCurrency.id) {
        setDefaultData({ currencyId: defaultCurrency.id })
        CurrencyIdPubSub.publish({ currencyId: defaultCurrency.id, forceUpload: false })
      }
    }
    run();
    setTimeout(() => {
      formRef.current?.resetFormValue({ tipo: "0", expenseId: expense?.id });
    });

  }, []);

  const onXMLFileLoad = async (fileData: unknown) => {
    setIsLoading(true)
    try {
      const { documentData } = await loadXmlDocument(fileData, ["NotaCreditoElectronica"])
      const defaultData: Partial<ExpenseNoteFormData> = {
        ...documentData,
        tipo: "0",// mark all as credit notes, debit note not supported yet
        expenseId: expense?.id
      }
      const filteredDocumentData = omitProperties(defaultData || {}, ["Products", "providerId", "identificacion", "pagada"])

      formRef.current?.resetFormValue(filteredDocumentData);
    } catch (err) {
      if (err instanceof Error) {
        showAlert("danger", err.message)
      }
    } finally {
      setIsLoading(false)
    }
  }

  const createExpense = (input: Omit<ExpenseNoteDataType, 'id'>): Promise<ExpenseNoteDataType> => {
    const expenseData: ExpenseNoteDataType = {
      ...input,
      tipo: "0",// mark all as credit notes, debit note not supported yet
      expenseId: expense?.id
    }

    return ExpenseNoteApi.create(expenseData)
  }

  return (
    <>
      <LoadXmlDataForm
        onFileLoaded={onXMLFileLoad}
      />
      <GenericForm<ExpenseNoteFormData, ExpenseNoteDataType>
        id={props.id}
        ref={formRef}
        formId={props.formId}
        defaultData={defaultData}
        saveRedirectUrl={props.saveRedirectUrl}
        modelRelativeObjects={ExpenseNoteRelatedAttributes}
        formConfig={ExpenseNoteFormConfig}
        getById={(...arg) => ExpenseNoteApi.get(...arg)}
        createFn={(...arg) => ExpenseNoteApi.create(...arg)}
        updateFn={(...arg) => createExpense(...arg)}
        successMessage="El gasto ha sido almacenada correctamente"
        errorMessage="No fue posible almacenar la información del gasto"
      />
      <LoadingScreen isLoading={isLoading} />

    </>
  )
}

export default ExpenseNoteForm;